import { SemanticICONS } from 'semantic-ui-react'
import { IndexSearchOption } from '../IndexSearch/types'

export type DamageManagerReferenceValues = {
	data: string
	link: string
}

export type DamageManagerDashboardFetch = {
	cards: {
		cardTitle: string
		cardBodyIcon?: SemanticICONS
		cardBodyText?: number
		cardLink: string
		notReact?: boolean
	}[]
}

export type DamageManagerIndexFetch = {
	headings?: {
		customer: string
		supplier: string
		reference: string
		type: string
		firstNotifcation: string
		insuranceType: string
		salesInvoice: string
		salesDate: string
		purchaseInvoice: string
		purchaseDate: string
	}
	data: {
		id: string
		customer?: string
		supplier: string
		reference: DamageManagerReferenceValues
		type: string
		firstNotifcation: string
		insuranceType?: string
		salesInvoice: string
		salesDate: string
		purchaseInvoice: string
		purchaseDate: string
		status: string
	}[]
	options: {
		[key: string]: { label: string; values: { [key: string]: string }[] }
	}
}

export type DamageManagerSearchOptionsFetch = {
	customer?: IndexSearchOption
	supplier?: IndexSearchOption
	status: IndexSearchOption
	reference: IndexSearchOption
	type: IndexSearchOption
	insuranceType?: IndexSearchOption
}
